import {
  TabaPayCardDetailsResult,
  TabaPayCardDetailsResultTypenames,
} from '@varo/graphql-schema-types';
import TabaPayCardDetails from 'services/graphql/queries/MoveMoney/TabaPayCardDetails';
import { useFormattedCombinedError } from 'shared/hooks/errorFormatters/useFormattedCombinedError/useFormattedCombinedError';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

interface TabaPayCardDetail {
  tabaPayCardDetails: TabaPayCardDetailsResult;
}

export const useTabaPayCardDetails = () => {
  const [{ data, fetching, error }] = useQuery<TabaPayCardDetail>({
    query: TabaPayCardDetails,
    requestPolicy: 'cache-and-network',
  });
  const responseError = useFormattedCombinedError(error);

  const details = data?.tabaPayCardDetails;
  let errorModel = responseError
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: responseError.title,
        messageBody: responseError.message,
        primaryButton: undefined,
        secondaryButton: undefined,
        is3DSError: false,
        analytics: undefined,
      }
    : null;

  if (
    data?.tabaPayCardDetails?.__typename ===
    TabaPayCardDetailsResultTypenames.TabaPayCardDetailsError
  ) {
    errorModel = {
      screenType: ErrorScreenType.Error,
      messageHeadline: data.tabaPayCardDetails.title,
      messageBody: data.tabaPayCardDetails.message,
      primaryButton: undefined,
      secondaryButton: undefined,
      is3DSError: false,
      analytics: undefined,
    };
  }

  const isValidDetails =
    details?.__typename ===
      TabaPayCardDetailsResultTypenames.TabaPayCardDetailsSuccess &&
    typeof details === 'object' &&
    'cardHolderName' in details;

  const fullName = isValidDetails ? details.cardHolderName?.full : undefined;

  const dropdownAddressList = isValidDetails
    ? details.associatedExternalCardAddresses.map((item) => item.address)
    : [];

  const disclaimer = isValidDetails ? details.disclaimer : undefined;
  const title = isValidDetails ? details.title : undefined;
  const description = isValidDetails ? details.description : undefined;
  const defaultAddress = isValidDetails
    ? details?.associatedExternalCardAddresses.find(
        (item) => item.isProfileAddress && item.address,
      )?.address
    : undefined;

  return {
    fullName,
    dropdownAddressList,
    defaultAddress,
    disclaimer,
    title,
    description,
    fetching,
    error: errorModel,
  };
};
